var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-clean"},[_c('BaseUiModal'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('BaseAlertsCookies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }